import React, { useState } from 'react';
import styles from './styles/login.module.css';
import { Helmet } from 'react-helmet';
import SignIn from './components/SignIn';
import CheckoutPopup from '../../components/sharedComponents/CheckoutPopup';
import { DtpUtils } from '../../utils/DtpUtils';
import { useNavigate } from "react-router-dom";
import StartTrackingButton from '../../components/sharedComponents/StartTrackingButton';

const Login = () => {

    const [togglePopup, setToggleOpup] = useState(false);
    const navigate = useNavigate();

    const openPopup = (togglePopup) => {
        const isOpne = DtpUtils.showCheckoutPopup(togglePopup);
        setToggleOpup(isOpne);
    }

    const closePopup = () => {
        setToggleOpup(!togglePopup);
        navigate(0);
    }

    return (
        <>
            <Helmet>
                <title>Device Tracker App, Get Peace of Mind with Device Tracker Plus</title>
                <meta name="description" content="Accurate device tracking & real-time location sharing for families, friends & couples. Stay connected with the world's no.1 mobile device tracker app." />
                <link rel="canonical" href="https://www.devicetrackerplus.com/login" />
            </Helmet>
            <div className={styles.bgcContainer}>
                <div className={styles.mainContainer}>
                    <div className={styles.pageCardContainer}>
                        <SignIn />
                        <div className={styles.createAccountContainer}>
                            <h4 className={styles.createAccountHeader}>Dont't have an account?</h4>
                            <p className={styles.createAccountParagraph}>Joint to Device Tracker Plus Family...</p>
                            <StartTrackingButton title="Join Now" style={styles.startTrackingButton} onButtonClick={openPopup} />
                        </div>
                    </div>
                </div>
            </div>
            {togglePopup &&
                <CheckoutPopup closePopup={closePopup} country={''} carrier={''} confrmed={''} trial={0} userData={false} />}
        </>
    );
}

export default Login;